"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _materialReactTable = require("material-react-table");
var _Error = require("./Error");
var _mui_style_overrides = require("./mui_style_overrides");
var _no_adapprovals = _interopRequireDefault(require("./assets/no_adapprovals.png"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BasicTable = _ref => {
  let {
    table_data,
    table_columns,
    ...rest
  } = _ref;
  const columns = (0, _react.useMemo)(() => table_columns, []);
  const data = (0, _react.useMemo)(() => table_data, []);
  return /*#__PURE__*/_react.default.createElement(_materialReactTable.MaterialReactTable, (0, _extends2.default)({
    columns: columns,
    data: data,
    enableRowSelection: false,
    enableColumnFilters: false,
    enableFullScreenToggle: true,
    enableDensityToggle: true,
    positionGlobalFilter: "left",
    positionActionsColumn: rest.positionOfActionsColumn,
    enableToolbarInternalActions: false,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: rest.actionColumnName,
        //customize action column style
        Header: rest.customizeActionColumnJSX,
        enablePinning: true,
        enableColumnActions: true
      }
    },
    renderRowActions: tableDetails => rest.renderTableRowActions(tableDetails),
    getRowId: row => row === null || row === void 0 ? void 0 : row.id,
    initialState: {
      showGlobalFilter: true,
      ...rest.initialStateOptions
    },
    muiSearchTextFieldProps: {
      variant: "outlined",
      size: "small",
      helperText: rest.seachHelperText || "",
      sx: {
        width: "18.5rem"
      }
    },
    state: {
      ...rest.state
    },
    renderEmptyRowsFallback: () => {
      var _rest$errorApiFailed$, _rest$errorApiFailed, _rest$errorApiFailed$2, _rest$errorApiFailed2, _rest$errorNoResult$t, _rest$errorNoResult, _rest$errorNoResult$i, _rest$errorNoResult2, _rest$errorNoResult$d, _rest$errorNoResult3;
      return rest.isError ? /*#__PURE__*/_react.default.createElement(_Error.TableError, {
        title: (_rest$errorApiFailed$ = (_rest$errorApiFailed = rest.errorApiFailed) === null || _rest$errorApiFailed === void 0 ? void 0 : _rest$errorApiFailed.title) !== null && _rest$errorApiFailed$ !== void 0 ? _rest$errorApiFailed$ : "API Failed.",
        description: (_rest$errorApiFailed$2 = (_rest$errorApiFailed2 = rest.errorApiFailed) === null || _rest$errorApiFailed2 === void 0 ? void 0 : _rest$errorApiFailed2.description) !== null && _rest$errorApiFailed$2 !== void 0 ? _rest$errorApiFailed$2 : "Please try again after some time"
      }) : /*#__PURE__*/_react.default.createElement(_Error.TableError, {
        title: (_rest$errorNoResult$t = (_rest$errorNoResult = rest.errorNoResult) === null || _rest$errorNoResult === void 0 ? void 0 : _rest$errorNoResult.title) !== null && _rest$errorNoResult$t !== void 0 ? _rest$errorNoResult$t : "No search results found",
        imgUrl: (_rest$errorNoResult$i = (_rest$errorNoResult2 = rest.errorNoResult) === null || _rest$errorNoResult2 === void 0 ? void 0 : _rest$errorNoResult2.imgUrl) !== null && _rest$errorNoResult$i !== void 0 ? _rest$errorNoResult$i : _no_adapprovals.default,
        description: (_rest$errorNoResult$d = (_rest$errorNoResult3 = rest.errorNoResult) === null || _rest$errorNoResult3 === void 0 ? void 0 : _rest$errorNoResult3.description) !== null && _rest$errorNoResult$d !== void 0 ? _rest$errorNoResult$d : ""
      });
    }
  }, _mui_style_overrides.styles, rest));
};
BasicTable.defaultProps = {
  enableTableFooter: false
};
BasicTable.propTypes = {
  enableTableFooter: _propTypes.default.bool
};
var _default = exports.default = BasicTable;